"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MutatingDots = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MutatingDots = function MutatingDots(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      id: "goo-loader",
      width: props.width,
      height: props.height,
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("filter", {
      id: "fancy-goo"
    },
    /*#__PURE__*/
    _react["default"].createElement("feGaussianBlur", {
      "in": "SourceGraphic",
      stdDeviation: "6",
      result: "blur"
    }),
    /*#__PURE__*/
    _react["default"].createElement("feColorMatrix", {
      "in": "blur",
      mode: "matrix",
      values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
      result: "goo"
    }),
    /*#__PURE__*/
    _react["default"].createElement("feComposite", {
      "in": "SourceGraphic",
      in2: "goo",
      operator: "atop"
    })),
    /*#__PURE__*/
    _react["default"].createElement("g", {
      filter: "url(#fancy-goo)"
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      id: "mainAnim",
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 50 50",
      to: "359 50 50",
      dur: "1.2s",
      repeatCount: "indefinite"
    }),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "50%",
      cy: "40",
      r: props.radius,
      fill: props.color
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      id: "cAnim1",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0;cAnim1.end+0.2s",
      calcMode: "spline",
      values: "40;20;40",
      keyTimes: "0;0.3;1",
      keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "50%",
      cy: "60",
      r: props.radius,
      fill: props.secondaryColor
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      id: "cAnim2",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0.4s;cAnim2.end+0.2s",
      calcMode: "spline",
      values: "60;80;60",
      keyTimes: "0;0.3;1",
      keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
    }))))
  );
};

exports.MutatingDots = MutatingDots;
MutatingDots.propTypes = {
  width: _propTypes["default"].number,
  secondaryColor: _propTypes["default"].string,
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  radius: _propTypes["default"].number,
  label: _propTypes["default"].string
};
MutatingDots.defaultProps = {
  width: 80,
  height: 90,
  color: "green",
  radius: 11,
  secondaryColor: "green",
  label: "audio-loading"
};